<template>

  <!-- Header section containing logo and menu -->
  <header v-if="!isSplash()" class="adv-header mdl-layout__header mdl-color--blue-grey-900 mdl-color-text--white">
    <div class="mdl-layout__header-row adv-titlebar">      
      <!-- Logo -->
      <h4 class="adv-logo">
        <router-link to="/"><img src="images/logo.png" class="logo-adventify"> ADVENTIFY 
          <span v-if="isCreateMode()" style="position:relative; left: 5px; top: -3px; padding: 1px 3px; color: #263238; background-color: #ffffff; border-radius: 3px; font-size: 12px;">
            EDITOR</span>
        <div style="position: relative; top: -55px; left: 144px; height:0px; width: 0px; margin: 0; padding: 0; font-size: 10px; text-orientation: sideways; color: #FF5722; pointer-events: none; ">BETA</div>
        </router-link>
      </h4>

      <div class="mdl-layout-spacer"></div>

      <!-- Search bar -->
      <div class="adv-searchcontainer mdl-textfield mdl-js-textfield mdl-textfield--expandable">
        <label class="mdl-button mdl-js-button mdl-button--icon" for="searchQuery">
          <i class="material-icons">search</i>
        </label>
        <div class="mdl-textfield__expandable-holder">
          <input class="mdl-textfield__input" type="text" id="searchQuery">
          <label class="mdl-textfield__label" for="searchQuery">Enter your query...</label>
        </div>
        <div id="adv-searchResults" class="mdl-card mdl-shadow--2dp"></div>
      </div>

      <!-- Singed-in User Info -->
      <router-link to="/login" ><button :hidden="user" class="adv-sign-in-button mdl-button mdl-js-button mdl-js-ripple-effect"><i class="material-icons">account_circle</i> Sign in</button></router-link>
      <div :hidden="!user" class="adv-signed-in-user-container mdl-cell--hide-phone ">
        <a class="adv-usernamelink mdl-button mdl-js-button">
          <div class="adv-avatar" :style="getUserAvatar()"></div>
          <div class="adv-username mdl-color-text--white">{{user && (user.displayName || user.email)}}</div>
        </a>
      </div>

      <!-- Drop Down Menu -->
      <button class="mdl-button mdl-js-button mdl-js-ripple-effect mdl-button--icon mdl-cell--hide-phone" id="adv-menu">
        <i class="material-icons">more_vert</i>
      </button>
      <ul class="adv-menu-list mdl-menu mdl-js-menu mdl-js-ripple-effect mdl-menu--bottom-right" for="adv-menu" style="text-align: left;">
        <li><div class="nav-separator-title" >Play</div></li>
        <router-link to="/"><li class="mdl-menu__item"><i class="material-icons">gamepad</i> Adventures</li></router-link>
        <router-link v-if="user" to="/recent" ><li class="mdl-menu__item"><i class="material-icons">history</i> Recently Played</li></router-link>
        <router-link disabled style="pointer-events: none; opacity: 0.33;" to="/genres" ><li disabled class="mdl-menu__item" ><i  class="material-icons">view_module</i> Genres</li></router-link>
        <li v-if="user"><div class="nav-separator-title" >Create</div></li>
        <router-link v-if="user" to="/editor" ><li class="mdl-menu__item"><i class="material-icons">create</i> Adventure Editor</li></router-link>
        <router-link v-if="user" to="/documentation" ><li class="mdl-menu__item"><i class="material-icons">local_library</i> Documentation</li></router-link>
        <li><div class="nav-separator-title">Account</div></li>
        <router-link v-if="!user" to="/login" ><li class="mdl-menu__item"><i class="material-icons">account_circle</i> Sign In</li></router-link>
        <li v-if="user" class="adv-sign-out mdl-menu__item" @click='logOut'><i class="material-icons">exit_to_app</i> Sign out</li>
      </ul>
    </div>

    <!-- Navigation Bar -->
    <div class="adv-tab mdl-layout__header-row mdl-cell--hide-phone mdl-color--deep-orange">
      <div class="mdl-tab">
        <router-link to="/" v-if="!isCreateMode()" id="adv-menu-home" class="adv-player-menu mdl-layout__tab mdl-button mdl-js-button mdl-js-ripple-effect"><i class="material-icons">gamepad</i> Adventures</router-link>
        <router-link v-if="user && !isCreateMode()" to="/recent" id="adv-menu-recent" class="adv-player-menu mdl-layout__tab mdl-button mdl-js-button mdl-js-ripple-effect"><i class="material-icons">history</i> Recently Played</router-link>
        <router-link style="pointer-events: none;" disabled to="/genres" v-if="!isCreateMode()" id="adv-menu-genres" class="adv-player-menu mdl-layout__tab mdl-button mdl-js-button mdl-js-ripple-effect"><i class="material-icons">view_module</i> Genres</router-link>
        <router-link v-if="isCreateMode()" to="/editor" id="adv-menu-editor" class="adv-create-menu mdl-layout__tab mdl-button mdl-js-button mdl-js-ripple-effect">
        <i class="material-icons">create</i> My Adventures</router-link>
        <router-link v-if="isCreateMode()" to="/documentation" id="adv-menu-documentation" class="adv-create-menu mdl-layout__tab mdl-button mdl-js-button mdl-js-ripple-effect">
        <i class="material-icons">local_library</i> Documentation</router-link>
      </div>
    </div>
  </header>
  
</template>
<script>

var latinize = require('latinize');

export default{
  data: () => ({
    isCreateMode(){
      return this.$route.path.startsWith("/editor") || this.$route.path.startsWith("/documentation");
    },
    isSplash(){
      return this.$route.path === "/login";
    },
    getUserAvatar(){
      if(window.firebase.auth().currentUser) return 'background-image: url("' + (window.firebase.auth().currentUser.photoURL) + '")';
      return 'background-image: url("/images/silhouette.jpg")';
    },
    user: window.firebase.auth().currentUser
  }),
  created() {
    window.firebase.auth().onAuthStateChanged((user) => {
      this.user = user;
      if(user)
      this.saveUserData(user.photoURL, user.displayName);
    });
  },
  methods: {    
    logOut() { 
      window.firebase.auth().signOut();
    },
    /**
     * Saves or updates public user data in Firebase (such as image URL, display name...).
     */
    saveUserData(imageUrl, displayName) {
      if (!displayName) {
        displayName = 'Anonymous';
      }
      let searchFullName = displayName.toLowerCase();
      let searchReversedFullName = searchFullName.split(' ').reverse().join(' ');
      try {
        searchFullName = latinize(searchFullName);
        searchReversedFullName = latinize(searchReversedFullName);
      } catch (e) {
        console.error(e);
      }

      const updateData = {
        profile_picture: imageUrl,
        full_name: displayName,
        _search_index: {
          full_name: searchFullName,
          reversed_full_name: searchReversedFullName
        }
      };
      return  window.firebase.database().ref(`people/${ window.firebase.auth().currentUser.uid}`).update(updateData);
    }
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// SectionHeader.vue?f957c1d6